import objectPath from "object-path";
import React from "react";
import { API_ROOT } from "../../../defines";
import moment from "moment";
import { IoCalendarOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { PiEye } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
const Text = (text) => {
  let limit = 50;
  if (window.innerWidth > 768) limit = 350;

  const truncated =
    text.length > limit ? text.substring(0, limit) + "..." : text;

  return <div>{truncated}</div>;
};
const AdviceItem = ({ data }) => {
  const { t } = useTranslation();
  const title = objectPath.get(data, "title");
  const _id = objectPath.get(data, "_id");
  const created = objectPath.get(data, "created");
  const description = objectPath.get(data, "description");
  const views = objectPath.get(data, "views", 0);
  const file = objectPath.get(data, "file.0");
  const url = API_ROOT + "/" + objectPath.get(file, "id");
  const navigate = useNavigate();
  const media = () => {
    const { type } = file;

    if (type == "image")
      return (
        <img src={url} className="w-32 bg-contain" crossOrigin="anonymous" />
      );

    if (type == "video")
      return (
        <video
          key={url}
          className="w-full"
          controls="controls"
          crossOrigin="anonymous"
        >
          <source src={url}></source>
        </video>
      );
  };
  return (
    <div
      onClick={() => navigate(`/order/advice/view/${_id}`)}
      className="flex flex-col md:flex-row w-full p-8 rounded-md shadow-md bg-white mb-4 hover:cursor-pointer hover:border hover:border-primary"
    >
      <div className="flex items-center justify-center">{media()}</div>
      <div className="flex flex-col px-8 w-full">
        <div className="flex flex-col md:flex-row w-full justify-between items-center">
          <div className="font-medium text-lg my-2 md:my-0">{title}</div>
          <div className="flex items-center">
            <div className="flex items-center">
              <IoCalendarOutline color="#6B7280" size={16} />
              <div className="text-base text-gray-500 mt-0.5 ml-1">
                {moment(created).format("YYYY-MM-DD")}
              </div>
            </div>
            <div className="flex items-center ml-2">
              <PiEye color="#6B7280" size={16} />
              <div className="text-base text-gray-500 mt-0.5 ml-1">{views}</div>
            </div>
          </div>
        </div>
        <div className="flex text-sm text-justify my-2">
          {Text(description)}
        </div>
        <div className="flex w-full justify-end">
          <div className="text-xs text-blue-500 font-medium underline">
            {t("more")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdviceItem;
